<template lang="pug">
  .form-user.container
    section.section(v-if="!value.slides || value.slides.length === 0")
      b-loading(:active="isUpploadingFile")
      label.is-size-5 Импортировать презентацию из файла
      b-field.file.m-t-20(grouped)
        b-upload(v-model="importFile" accept="application/pdf")
          a.button.is-primary
            b-icon(icon="upload")
            span {{importFile ? importFile.name : 'Выбрать PDF файл'}}
        button.button.is-primary(v-if="importFile" @click="importPresentation") Отправить
    section.section
      .columns.is-multiline
        .column.is-6-tablet.is-6-desktop(v-if="value.slides" v-for="slide in value.slides" :key="slide.id")
          .images
            b-message(title=" " @close="removeSlide(slide.id)")
              ui-field(type="title" label="Заголовок" v-model="slide.title")
              ui-field(type="number" label="Номер слайда" v-model="slide.order")
              img(:src="slide.image ? slide.image : slide.data")
        .column.is-12
          b-field
            b-upload.is-block(v-model="dropFiles", multiple, drag-drop)
              section.section
                .content.has-text-centered
                  p: b-icon(icon="upload" size="is-large")
                  p Перетащите изображения слайдов сюда или нажмите для загрузки изображений
</template>

<script>
import api from '@/api';

export default {
  name: 'form-presentation',

  props: {
    value: null,
    errors: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      dropFiles: [],
      importFile: null,
      isUpploadingFile: false,
    };
  },

  watch: {
    dropFiles(files) {
      this.value.slides = this.value.slides.filter(slide => slide.id > 0);
      let orderIndex = this.value.slides.length + 1;

      files.map((file, index) => {
        let fileReader = new FileReader();
        fileReader.onload = () => {
          this.value.slides.push({
            id: -1 * (index + 1),
            title: '',
            order: orderIndex + index,
            file: file,
            data: fileReader.result,
          });
        };

        fileReader.readAsDataURL(file);
      });
    },
  },

  methods: {
    removeSlide(id) {
      if (id > 0) {
        this.value.slides = this.value.slides.filter(slide => slide.id !== id);
      } else {
        const fileToDrop = this.value.slides.find(slide => {
          return slide.id === id;
        });

        this.dropFiles = this.dropFiles.filter(file => file !== fileToDrop.file);
      }
    },

    async importPresentation() {
      this.isUpploadingFile = true;
      await api.for(`presentations/${this.value.id}/import`).create({
        presentation: this.importFile,
      });

      this.isUpploadingFile = false;
      this.value.$find(this.value.id, { include: 'slides' });
    },
  },
};
</script>
